/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchnellauswahlDto } from '../../models/schnellauswahl-dto';

export interface GetAllSchnellauswahlmoeglichkeiten$Json$Params {
}

export function getAllSchnellauswahlmoeglichkeiten$Json(http: HttpClient, rootUrl: string, params?: GetAllSchnellauswahlmoeglichkeiten$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SchnellauswahlDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllSchnellauswahlmoeglichkeiten$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SchnellauswahlDto>>;
    })
  );
}

getAllSchnellauswahlmoeglichkeiten$Json.PATH = '/v1/schnellauswahl';
